import React from 'react';
import './Login.css';
import { AuthContext } from "../../contexts/AuthContext";
import {
  Box,
  Typography,
  TextField,
  Grid2,
  FormControlLabel,
  Checkbox
} from "@mui/material";
import { useState, useContext } from "react";
import { useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";
import ImgLogin from "../../img/login.jpg";
import ImgLogo from "../../img/logo-3rr.png";
import Switch from "../../components/switch";
import Button from '../../components/button';

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const { login } = useContext(AuthContext)!; 
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      setError(null); 
      await login(email, password);
      navigate("/pedidos"); 
    } catch (err: any) {
      setError(err.message || "Email ou senha inválidos.");
    }
  };

    return (
        <Grid2 container sx={{ height: "100vh", justifyContent:"space-around" }}>
          <Grid2 spacing={{xs: 12, md:6}}
            sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: 4,
                  '@media (max-width: 1250px)': {
                    marginTop:0,
                    overflow: "hidden",
                    padding: 2
                  }
              }}>
          <Box sx={{ mb: 4 }}>
            <img src={ImgLogo} alt="Logo RiberSolo" style={{ width: "200px" }} />
          </Box>
          <Box component="form" sx={{ width: "100%", maxWidth: 400 }}>
            <TextField
              fullWidth
              label="E-mail"
              variant="outlined"
              margin="normal"
              onChange={(e) => setEmail(e.target.value)}
            />
            <TextField
              fullWidth
              label="Senha"
              type="password"
              variant="outlined"
              margin="normal"
              onChange={(e) => setPassword(e.target.value)}
            />
            {error && <Typography className='error-message'>{error}</Typography>}
            {/*<Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mt: 1,
                mb: 3,
              }}>
              <FormControlLabel control={ <Switch />} label="Lembrar de Mim" />
              <Typography
                variant="body2"
                component="a"
                href="#"
                sx={{ color: " #2D7A89", textDecoration: "none" }}>
                Esqueci a senha
              </Typography>
            </Box>*/}
            <Button onClick={handleLogin} label='Entrar' backgroundColor='var(--primary-color)' sx={{mt: 2}}/>
          </Box>
        </Grid2>
  
        <Grid2
          spacing={{xs: 12, md:6}}
          sx={{
            width: "800px",
            height: "100vh",
            backgroundColor: "#fffff",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "stretch",
            position: "relative",
            overflow: "hidden",
            '@media (max-width: 1250px)': {
              display: 'none'
            }
          }}
        >
        <Box className="imageWithGradient">
          <Typography className="initialText">
            Mais assertividade para o campo com o que há de melhor em análises laboratoriais.
          </Typography>
        </Box>
        </Grid2>
      </Grid2>
    );
  };

export default Login; 